<template>
  <div id="app">
    <router-view v-if="isRouterALive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterALive: true
    }
  }, methods: {
    reload() {
      this.isRouterALive = false;
      this.$nextTick(() => {
        this.isRouterALive = true;
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue